import { TopBarMenuItem, TopBarMenuItemProps } from './TopBarMenuItem';
import { Bell } from 'components/gruenland/icons/Bell';

export type AnnouncementBarProps = {
  text: string;
  menu: Array<TopBarMenuItemProps>;
};

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({ text, menu }) => {
  return (
    <div className="flex min-h-10 items-center justify-between bg-primary-green px-[10px] md:px-10">
      <div className="flex items-center gap-3 text-[14px]/[17.64px] font-medium tracking-[.02em] text-white">
        <Bell className="hidden text-accent-green-light md:inline" width={22} height={22} />
        {text}
      </div>
      <div className="hidden items-center gap-8 md:flex">
        {menu.map((x, i) => (
          <TopBarMenuItem key={i} icon={x.icon} label={x.label} link={x.link} />
        ))}
      </div>
    </div>
  );
};
export default AnnouncementBar;
